import { render, staticRenderFns } from "./priceCombinationStep2.vue?vue&type=template&id=11db4df2&scoped=true&"
import script from "./priceCombinationStep2.vue?vue&type=script&lang=js&"
export * from "./priceCombinationStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11db4df2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11db4df2')) {
      api.createRecord('11db4df2', component.options)
    } else {
      api.reload('11db4df2', component.options)
    }
    module.hot.accept("./priceCombinationStep2.vue?vue&type=template&id=11db4df2&scoped=true&", function () {
      api.rerender('11db4df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Price/priceCombinationStep2.vue"
export default component.exports